import {ReportModel} from "@fedeltapointofsale/data-client";
import {Injectable, Injector} from "@angular/core";
import {StockTransferReportData} from "./stock-transfer-report.data";

@Injectable()
export class StockTransferReportModel extends ReportModel<StockTransferReportData> {

    constructor(injector: Injector) {
        super(injector, StockTransferReportData);
    }
}
